import PropTypes from "prop-types";

import { ZipField } from "UI/FnrAddress";

import { useAutocompleteContext } from "./AutocompleteContext";
import ShadowField from "./ShadowField";

/**
 * Zip field auto-wired to the autocomplete context.
 */
export default function AutocompleteZipField({ disabled, countryID }) {
  const { value, onChange, shadows, onFieldBlur, zipRef } =
    useAutocompleteContext();
  const typed = value.zip || "";
  return (
    <ShadowField inputRef={zipRef} typed={typed} suffix={shadows.zip}>
      <ZipField
        ref={zipRef}
        disabled={disabled}
        value={typed}
        onChange={(e) => onChange({ zip: e.target.value })}
        onBlur={() => onFieldBlur("zip")}
        countryIDOrCode={countryID}
        placeholder={shadows.zip ? "" : undefined}
      />
    </ShadowField>
  );
}

AutocompleteZipField.propTypes = {
  disabled: PropTypes.bool,
  countryID: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
